import { useRouteLoaderData } from 'react-router'

import { AppLoaderData } from '~/portal/types/app'

/** True when a personalized STS token is expected for this visitor; try-it-out is then forced through the proxy */
export const usePersonalizedAuth = (): boolean => {
  const data = useRouteLoaderData<AppLoaderData>('root')
  return data?.personalizedAuth?.active === true
}
